import { FIELDS } from '@/pages/Invoices/constants';
const defaultFields = [
  // {
  //   field: 'commands',
  //   title: '',
  //   cell: 'commands',
  //   headerCell: 'commandsHeader',
  //   sortable: false,
  //   hidden: true,
  //   locked: true,
  //   width: 40,
  // },
  {
    key: 'Id',
    cell: 'navigation',
    field: FIELDS.ID,
    title: 'Invoice No',
    label: 'Invoice No',
    sortable: true,
    hidden: false,
    locked: true,
    width: 75,
  },
  {
    key: 'InvoiceDate',
    cell: 'formatDate',
    field: FIELDS.INVOICE_DATE,
    title: 'Invoice Date',
    label: 'Invoice Date',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    key: 'DueDate',
    cell: 'formatDate',
    field: FIELDS.DUE_DATE,
    title: 'Due Date',
    label: 'Due Date',
    sortable: true,
    hidden: false,
    width: 110,
  },
  {
    key: 'StatusName',
    field: FIELDS.STATUS_NAME,
    title: 'Status Name',
    label: 'Status Name',
    sortable: true,
    hidden: false,
    width: 75,
  },
  {
    key: 'CompanyName',
    field: FIELDS.COMPANY_NAME,
    title: 'Company Name',
    label: 'Company Name',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Contact',
    field: FIELDS.CONTACT,
    title: 'Contact',
    label: 'Contact',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ShipTo',
    field: FIELDS.SHIP_TO,
    title: 'Ship To',
    label: 'Ship To',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'BillTo',
    field: FIELDS.BILL_TO,
    title: 'Bill To',
    label: 'Bill To',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'BillingTermName',
    field: FIELDS.BILLING_TERM_NAME,
    title: 'Terms',
    label: 'Terms',
    sortable: true,
    hidden: false,
    width: 75,
  },
  {
    key: 'IncoTermName',
    field: FIELDS.INCO_TERM_NAME,
    title: 'Inco Term',
    label: 'Inco Term',
    sortable: true,
    hidden: false,
    width: 75,
  },
  {
    key: 'SalesPersonUserFullName',
    field: FIELDS.SALES_PERSON_USER_FULL_NAME,
    title: 'Sales Person',
    label: 'Sales Person',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Aging',
    field: FIELDS.AGING,
    title: 'Aging',
    label: 'Aging',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    key: 'ShipDate',
    cell: 'formatDate',
    field: FIELDS.SHIP_DATE,
    title: 'Ship Date',
    label: 'Ship Date',
    sortable: true,
    hidden: false,
    width: 110,
  },
  {
    key: 'ContractNumber',
    field: FIELDS.CONTRACT_NUMBER,
    title: 'Contract Number',
    label: 'Contract Number',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    key: 'CustomerPO',
    field: FIELDS.CUSTOMER_PO,
    title: 'Customer PO',
    label: 'Customer PO',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    key: 'CurrencyTypeName',
    field: FIELDS.CURRENCY_TYPE_NAME,
    title: 'Currency Type',
    label: 'Currency Type',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    key: 'ExchangeRate',
    field: FIELDS.EXCHANGE_RATE,
    title: 'Exch Rate',
    label: 'Exch Rate',
    sortable: true,
    hidden: false,
    width: 75,
  },
  {
    key: 'ShippingProviderName',
    field: FIELDS.SHIPPING_PROVIDER_NAME,
    title: 'Shipping Provider',
    label: 'Shipping Provider',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    key: 'ShippingMethodName',
    field: FIELDS.SHIPPING_METHOD_NAME,
    title: 'Shipping Method',
    label: 'Shipping Method',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    key: 'ShippedByUserFullName',
    field: FIELDS.SHIPPED_BY_USER_FULL_NAME,
    title: 'Shipped By',
    label: 'Shipped By',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    key: 'ShipOnCustAccount',
    field: FIELDS.SHIP_ON_CUST_ACCOUNT,
    title: 'Ship On Cust Account',
    label: 'Ship On Cust Account',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    key: 'ShippingNumber',
    field: FIELDS.SHIPPING_NUMBER,
    title: 'Shipping Number',
    label: 'Shipping Number',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    key: 'TaxRate',
    field: FIELDS.TAX_RATE,
    title: 'Tax Rate',
    label: 'TaxRate',
    sortable: true,
    hidden: false,
    width: 35,
  },
  {
    key: 'IsTaxable',
    field: FIELDS.IS_TAXABLE,
    title: 'Is Taxable',
    label: 'IsTaxable',
    sortable: true,
    hidden: false,
    width: 35,
  },
  {
    key: 'TaxNumber',
    field: FIELDS.TAX_NUMBER,
    title: 'Tax Number',
    label: 'Tax Number',
    sortable: true,
    hidden: false,
    width: 75,
  },
  {
    key: 'Tax',
    field: FIELDS.TAX,
    title: 'Tax',
    label: 'Tax',
    sortable: true,
    hidden: false,
    width: 35,
  },
  {
    key: 'SubTotal',
    field: FIELDS.SUB_TOTAL,
    title: 'Sub Total',
    label: 'Sub Total',
    cell: 'formatCurrency',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    key: 'TotalLineCost',
    field: FIELDS.TOTAL_LINE_COST,
    title: 'Total Line Cost',
    label: 'Total Line Cost',
    cell: 'formatCurrency',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    key: 'TotalChargesTaxable',
    field: FIELDS.TOTAL_CHARGES_TAXABLE,
    title: 'Total Charges Taxable',
    label: 'Total Charges Taxable',
    cell: 'formatCurrency',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    key: 'TotalChargesNonTaxable',
    field: FIELDS.TOTAL_CHARGES_NON_TAXABLE,
    title: 'Total Charges Non Taxable',
    label: 'Total Charges Non Taxable',
    cell: 'formatCurrency',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    key: 'TotalCharges',
    field: FIELDS.TOTAL_CHARGES,
    title: 'Total Charges',
    label: 'Total Charges',
    cell: 'formatCurrency',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    key: 'TotalChargesCost',
    field: FIELDS.TOTAL_CHARGES_COST,
    title: 'Total Charges Cost',
    label: 'Total Charges Cost',
    cell: 'formatCurrency',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    key: 'CreditAmount',
    field: FIELDS.CREDIT_AMOUNT,
    title: 'Credit Amount',
    label: 'Credit Amount',
    cell: 'formatCurrency',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    key: 'Total',
    field: FIELDS.TOTAL,
    title: 'Total',
    label: 'Total',
    cell: 'formatCurrency',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    key: 'SubTotalConverted',
    field: FIELDS.SUB_TOTAL_CONVERTED,
    title: 'Sub Total Converted',
    label: 'Sub Total Converted',
    cell: 'formatCurrencyConverted',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    key: 'TotalLineCostConverted',
    field: FIELDS.TOTAL_LINE_COST_CONVERTED,
    title: 'Total Line Cost Converted',
    label: 'Total Line Cost Converted',
    cell: 'formatCurrencyConverted',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    key: 'TotalChargesTaxableConverted',
    field: FIELDS.TOTAL_CHARGES_TAXABLE_CONVERTED,
    title: 'Total Charges Taxable Converted',
    label: 'Total Charges Taxable Converted',
    cell: 'formatCurrencyConverted',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    key: 'TotalChargesNonTaxableConverted',
    field: FIELDS.TOTAL_CHARGES_NON_TAXABLE_CONVERTED,
    title: 'Total Charges Non-Taxable Converted',
    label: 'Total Charges Non-Taxable Converted',
    cell: 'formatCurrencyConverted',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    key: 'TotalChargesConverted',
    field: FIELDS.TOTAL_CHARGES_CONVERTED,
    title: 'Total Charges Converted',
    label: 'Total Charges Converted',
    cell: 'formatCurrencyConverted',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    key: 'TotalChargesCostConverted',
    field: FIELDS.TOTAL_CHARGES_COST_CONVERTED,
    title: 'Total Charges Cost Converted',
    label: 'Total Charges Cost Converted',
    cell: 'formatCurrencyConverted',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    key: 'TotalConverted',
    field: FIELDS.TOTAL_CONVERTED,
    title: 'Total Converted',
    label: 'Total Converted',
    cell: 'formatCurrencyConverted',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    key: 'GrossProfit',
    field: FIELDS.GROSS_PROFIT,
    title: 'Gross Profit',
    label: 'Gross Profit',
    cell: 'formatCurrency',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    key: 'GPMargin',
    field: FIELDS.GPMARGIN,
    title: 'GP Margin',
    label: 'GP Margin',
    cell: 'formatPercentage',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    key: 'AmountPaid',
    field: FIELDS.AMOUNT_PAID,
    title: 'Amount Paid',
    label: 'Amount Paid',
    cell: 'formatAmount',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    key: 'Balance',
    field: FIELDS.BALANCE,
    title: 'Balance',
    label: 'Balance',
    sortable: true,
    hidden: false,
    cell: 'formatCurrency',
    width: 100,
  },
  {
    key: 'TrackingNumber',
    field: FIELDS.TRACKING_NUMBER,
    title: 'Tracking Number',
    label: 'Tracking Number',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    key: 'DateCreated',
    cell: 'formatDate',
    field: FIELDS.DATE_CREATED,
    title: 'Date Created',
    label: 'Date Created',
    sortable: true,
    hidden: false,
    width: 110,
  },
  {
    key: 'Comments',
    field: FIELDS.COMMENTS,
    title: 'Comments',
    label: 'Comments',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'InternalComments',
    field: FIELDS.INTERNAL_COMMENTS,
    title: 'Internal Comments',
    label: 'Internal Comments',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'IsAuthorized',
    field: FIELDS.IS_AUTHORIZED,
    title: 'Is Authorized',
    label: 'Is Authorized',
    sortable: true,
    hidden: false,
    width: 35,
  },
  {
    key: 'AuthorizedByUserFullName',
    field: FIELDS.AUTHORIZED_BY_USER_FULL_NAME,
    title: 'Authorized By',
    label: 'Authorized By',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    key: 'DateAuthorized',
    field: FIELDS.DATE_AUTHORIZED,
    cell: 'formatDate',
    title: 'Date Authorized',
    label: 'Date Authorized',
    sortable: true,
    hidden: false,
    width: 110,
  },
  {
    key: 'OnHold',
    field: FIELDS.ON_HOLD,
    title: 'On Hold',
    label: 'On Hold',
    sortable: true,
    hidden: false,
    width: 35,
  },
  {
    key: 'IsProforma',
    field: FIELDS.IS_PROFORMA,
    title: 'Is Proforma',
    label: 'Is Proforma',
    sortable: true,
    hidden: false,
    width: 35,
  },
  {
    key: 'CreatedByUserFullName',
    field: FIELDS.CREATED_BY_USER_FULL_NAME,
    title: 'Created By',
    label: 'Created By',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    key: 'DateModified',
    cell: 'formatDate',
    field: FIELDS.DATE_MODIFIED,
    title: 'Date Modified',
    label: 'DateModified',
    sortable: true,
    hidden: false,
    width: 110,
  },
  {
    key: 'ModifiedByUserFullName',
    field: FIELDS.MODIFIED_BY_USER_FULL_NAME,
    title: 'Modified By',
    label: 'Modified By',
    sortable: true,
    hidden: false,
    width: 100,
  },
  {
    field: 'deletecommands',
    title: '',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export default defaultFields;
